import * as Types from './types';
export function setForm(form) {
    var action = {
        type: Types.SET_FORM,
        form: form,
    };
    return action;
}
export function addFormStep(form) {
    var action = {
        type: Types.ADD_FORM_STEP,
        form: form,
    };
    return action;
}
export function setFormInfo(formInfo) {
    var action = {
        type: Types.SET_FORM_INFO,
        formInfo: formInfo,
    };
    return action;
}
export function resetFormState() {
    var action = {
        type: Types.RESET_FORM_STATE
    };
    return action;
}
export function setProgressForm(form) {
    return { type: Types.SET_PROGRESS_FORM, form: form };
}
export function setDocumentDataReview(documentDataReview) {
    return { type: Types.SET_DOCUMENT_DATA_REVIEW, documentDataReview: documentDataReview };
}
